import React from 'react';
import { Link } from 'react-router-dom';

/**
 * AppFooter — discrete legal links shown on both consumer and Talent Connect.
 * Uses surface-neutral styling so it inherits parent theme.
 */
export default function AppFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="sv-app-footer" data-testid="app-footer">
      <span className="sv-app-footer-copy">© {year} SignVoice</span>
      <span className="sv-app-footer-dot" aria-hidden="true">·</span>
      <Link to="/privacy" className="sv-app-footer-link" data-testid="footer-privacy">Privacy</Link>
      <span className="sv-app-footer-dot" aria-hidden="true">·</span>
      <Link to="/terms" className="sv-app-footer-link" data-testid="footer-terms">Terms</Link>
    </footer>
  );
}
